<div
  *ngIf="isImpersonationUser"
  fxLayout="row"
  fxLayoutAlign="space-between center"
  class="header impersonate-header"
  data-test-id="hdContainer"
>
  <div
    fxFlex="none"
    fxLayout="row"
    fxLayoutAlign="start center"
    class="logo-container"
    data-test-id="hdLogoContainer"
  >
    <cigna-header-logo
      [ngClass]="isImpersonatorSignin ? 'none' : 'impersonatorNonSigninLogo'"
      [enableToggleSidNav]="true"
      [isImpersonator]="isImpersonationUser"
      [attr.data-test-id]="'hdLogoConmponent'"
    ></cigna-header-logo>
  </div>
  <div
    *ngIf="isImpersonatorSignin"
    fxFlex
    fxLayoutAlign="start center"
    fxHide.lt-lg
    class="impersonator-info-section"
  ></div>
  <div
    fxLayout="row"
    fxLayoutAlign="end center"
    fxFlex="none"
    class="header-actions"
  >
    <button
      *ngIf="isImpersonatorSignin"
      [routerLink]="'/secure/broker-messages'"
      class="messages-button"
      mat-raised-button
      fxHide.lt-sm
    >
      <cigna-icon class="bell-icon"></cigna-icon>
      <span class="messages-button-text">{{
        'broker.mymessages' | translate
      }}</span>
    </button>
    <button
      mat-button
      class="icon-wrap hamburger-toggle"
      data-test-id="btnHiddenResToggleBtn"
      tabindex="0"
      [matMenuTriggerFor]="menu"
      #hamburgerMenuTrigger="matMenuTrigger"
      (click)="hamburgerMenuTrigger.openMenu()"
      fxHide.gt-md
    >
      <div class="header-icon hamburger-icon"></div>
    </button>
    <a
      class="brportal-right-nav-wrap topHeadItem topHeadLastItem"
      data-test-id="linkLoginInfo"
      tabindex="0"
      [matMenuTriggerFor]="menu"
      #loginMenuTrigger="matMenuTrigger"
      (focus)="loginMenuTrigger.openMenu()"
    >
      <div class="logininfo-icon-wrapper">
        <div class="logininfo-icon">
          <div data-test-id="lblLoginDetailCircle">
            {{
              (firstName ? firstName : internalFirstName)
                ?.trim()
                .substring(0, 1)
                .toUpperCase()
            }}{{
              (lastName ? lastName : internalLastName)
                ?.trim()
                .substring(0, 1)
                .toUpperCase()
            }}
          </div>
        </div>
      </div>
      <div class="logininfo-name" data-test-id="lblLoginName">
        {{ firstName ? firstName : internalFirstName }}
        {{ lastName ? lastName : internalLastName }}
        <span class="logininfo-name-selection">
          <cigna-icon [type]="'chevron-thin-down'"></cigna-icon>
        </span>
      </div>
    </a>
  </div>
  <mat-menu
    #menu="matMenu"
    class="top-right-nav-tablet-width"
    data-test-id="drpLoginMenu"
    [class]="'brportal-topnav-wrap'"
    [ngClass]="isCloseIconClicked ? 'hideMenu' : 'showMenu'"
  >
    <ng-container>
      <div class="close-icon-container" fxHide.gt-xs>
        <button mat-button class="icon-wrap float-r" (click)="closeIcon()">
          <div fxLayout="row" fxLayoutAlign="start center">
            <div class="close-text">{{ 'global.close' | translate }}</div>
            <div class="header-icon close-icon"></div>
          </div>
        </button>
      </div>
    </ng-container>
    <ng-container>
      <button
        mat-menu-item
        data-test-id="btnLoginMenuSecurityProfile"
        tabindex="0"
        *ngIf="isUseOnly"
        (click)="securityProfile()"
      >
        {{ 'header.securityProfile1' | translate }}
      </button>
    </ng-container>
    <button
      mat-menu-item
      (click)="processLogout(isImpersonatorSignin)"
      data-test-id="btnLoginMenuLogout"
      tabindex="0"
    >
      {{ 'header.logout' | translate }}
    </button>
  </mat-menu>
</div>

<div
  fxLayout="row"
  class="header-info header-info-1"
  *ngIf="isImpersonatorSignin"
>
  <div class="header-info-text">
    <span class="eye-icon icon-width" aria-hidden="true"></span>&nbsp;

    <span class="impersonator-lan-id">
      Impersonator: <span class="bold-text">{{ operatorId }}</span> |

      {{ 'imperonateTool.impStaticHeaderTxt1' | translate }}
      <a class="req-access-ink" (click)="showContactModal()"
        ><span class="bold-text">{{
          'imperonateTool.impStaticHeaderTxt2' | translate
        }}</span></a
      >
      {{ 'imperonateTool.impStaticHeaderTxt3' | translate }}
    </span>
  </div>
</div>
